export default {
  // RECEPTION
  CREATE_RECEPTION: "create_reception",
  EDIT_RECEPTION: "edit_reception",
  RECEPTION: "reception",
  ATTACH_INVOICE: "attach_invoice",
  NRCD: "nrcd",
  QUARANTINE: "quarantine",
  PREVIEW_QUARANTINE: "preview_quarantine",
  RECEIVED_PRODUCTS: "received_products",
  EDIT_RECEIVED_PRODUCTS: "edit_received_products",
  TRANSFER_RECEIVED: "transfer_received",
  TRANSFER_RECEIVED_SPLIT: "transfer_received_split",
  TRANSFER_TASKS: "transfer_tasks",
  RAPORTS: "raports",
  MONITOR_QUARANTINE: "monitor_quarantine",
  RETURNS: "returns",
  CREATE_RETURN: "create_return",
  // PUTAWAY
  PUTAWAY_TASKS: "putaway_tasks",
  PUTAWAY_REARRANGEMENT_TASKS: "putaway_rearrangement_tasks",
  PUTAWAY_REFILL_TASKS: "putaway_refill_tasks",
  // PICKING
  VERIFY_COMMAND: "verify_command",
  PRINT_COMMAND_INVOICES: "print_command_invoices",
  PRINT_COMMAND_PACKAGES: "print_command_packages",
  DELIVERY_ARRANGEMENT: "delivery_arrangement",
  SPLIT_INVOICES: "split_invoices",
  // EXPEDITION
  SCHEDULE_WORKING_POINTS: "schedule_working_points",
  WORKING_POINTS_ORGANIZE: "working_points_organize",
  SCHEDULE_WORKING_ROUTE: "schedule_working_route",
  WORKING_ROUTES_ORGANIZE: "working_routes_organize",
  NODES: "nodes",
  EDIT_NODES_ROUTES: "edit_nodes_routes",
  INCOMPLETE_INVOICES: "incomplete_invoices",
  SCAN_PLASTIC_BOXES: "scan_plastic_boxes",
  VERIFY_PLASTIC_BOXES: "verify_plastic_boxes",
  MONITORING_PLASTIC_BOXES: "monitoring_plastic_boxes",
  // INVENTORY
  INVENTORY_RECEIVED_PRODUCTS: "inventory_received_products",
  STOCKS: "stocks",
  DEPOSIT_STOCKS_ACTION: "deposit_stocks_action",
  NOMENCLATURE: "nomenclature",
  EDIT_PRODUCT_NOMENCLATURE: "edit_product_nomenclature",
  EDIT_PACKAGE_NOMENCLATURE: "edit_package_nomenclature",
  EDIT_LIMIT_NOMENCLATURE: "edit_limit_nomenclature",
  DEACTIVATE_PRODUCT_NOMENCLATURE: "deactivate_product_nomenclature",
  // ADMIN
  PREVIEW_USERS: "preview_users",
  CREATE_USER: "create_user",
  EDIT_USER: "edit_user",
  ADMINISTRATE_USER_ROLES: "administrate_user_web_roles",
  ADMINISTRATE_USER_MOBILE_ROLES: "administrate_user_mobile_roles",
};
